import {LoadingButton} from '@mui/lab';
import {
    Button,
    Chip,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    Stack,
    TextField,
    Typography,
} from '@mui/material';
import {DataGrid} from '@mui/x-data-grid';
import {useFormik} from 'formik';
import {useSnackbar} from 'notistack';
import {useMemo, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import server from '../../../global/server';
import {useFetch} from '../../../hooks/useFetch';
import useHandleErrors from '../../../hooks/useHandleErrors';
import SpecialtyForm from '../components/SpecialtyForm';
import {Close} from '@mui/icons-material';
import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
    name: Yup.string().required('Campo obrigatório'),
    amount: Yup.string().required('Campo obrigatório'),
    memedId: Yup.string().required('Informe o Id Memed')
});

export default () => {
    const navigation = useNavigate();
    const {data, mutate, error, isFetching} = useFetch('/product');
    const [errs, setErrs] = useState();
    const [viewDialog, setViewDialog] = useState(false);
    const {enqueueSnackbar} = useSnackbar();
    useHandleErrors(errs);

    const {
        handleChange,
        handleSubmit,
        handleReset,
        setValues,
        setFieldValue,
        values,
        errors,
        isSubmitting,
        setSubmitting,
    } = useFormik({
        initialValues: {
            name: '',
            amount: '',
            memedId : '',
            status: true,
        },
        validationSchema: validationSchema,
        onSubmit: async (values, {setSubmitting}) => {
            try {
                console.log(values);
                setSubmitting(true);

                if (values.id) {
                    values.amount = Number(values.amount);
                    const {data} = await server.put('/product', values);
                    enqueueSnackbar('Especialidade alterada');
                    setViewDialog(false);
                } else {
                    values.amount = Number(values.amount);
                    const {data} = await server.post('/product', values);
                    enqueueSnackbar('Especialidade adicionada');
                }
                setSubmitting(false);
                await mutate();
                handleClose();
            } catch (error) {
                setSubmitting(false);
                setErrs(error);
            }
        },
    });

    const handleDelete = async id => {
        try {
            await server.delete(`/specialty/${id}`);
            await mutate();
            handleClose();
            enqueueSnackbar('Empresa removida');
        } catch (error) {
            setSubmitting(false);
            setErrs(error);
        }
    };

    const columns = useMemo(() => [
        {field: 'id', headerName: 'ID', width: 50},
        {
            field: 'name',
            headerName: 'Nome',
            flex: 1,
        },
        {
            field: 'amount',
            headerName: 'Valor',
            flex: 1,
            valueFormatter: value => {
                if (value == null || value === '') return '';
                return Number(value).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                });
            },
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1,
            valueFormatter: value => (value ? 'Ativo' : 'Inativo'),
        },

        {
            field: 'actions',
            type: 'actions',
            renderCell: ({row}) => (
                <Button
                    onClick={e => {
                        setValues(row, false);
                        setViewDialog(true);
                    }}>
                    Alterar
                </Button>
            ),
        },
    ]);

    const handleClose = () => {
        setViewDialog(false);
        handleReset();
    };
    return (
        <Container fixed>
            <Stack direction="row" alignItems="center" justifyContent="space-between" columnGap={2}>
                <Typography variant="h5" component="h2" my={3}>
                    Especialidades
                </Typography>
                <Button variant="contained" onClick={e => setViewDialog(true)}>
                    Adicionar especialidade
                </Button>
            </Stack>
            <DataGrid autoHeight loading={isFetching} rows={data || []} columns={columns} />
            <Dialog
                components="form"
                open={viewDialog}
                onClose={e => {
                    handleReset();
                    setViewDialog(false);
                }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <DialogTitle>Especialidade</DialogTitle>
                    <IconButton
                        onClick={() => {
                            setViewDialog(false);
                            handleReset();
                        }}>
                        <Close />
                    </IconButton>
                </Stack>
                <Divider />
                <DialogContent>
                    <SpecialtyForm
                        values={values}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        errors={errors}
                    />
                </DialogContent>
                <Divider />
                <DialogActions>
                    {values.id && (
                        <Button
                            color="error"
                            onClick={e =>
                                window.confirm('Você tem certeza?') && handleDelete(values.id)
                            }>
                            Excluir
                        </Button>
                    )}
                    <Button onClick={e => setViewDialog(false)}>Cancelar</Button>
                    <LoadingButton onClick={handleSubmit}>Salvar</LoadingButton>
                </DialogActions>
            </Dialog>
        </Container>
    );
};
